import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD, PATH_AUTH } from '../routes/paths';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, isVerified, isOnboardingDone } = useAuth();
  const { pathname } = useLocation();

  if (isAuthenticated && isVerified && !isOnboardingDone) {
    return <Navigate to="/auth/onboarding" />;
  }

  if (isAuthenticated && isVerified) {
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  if (pathname === '/auth/verify' && !isAuthenticated) {
    return <Navigate to={PATH_AUTH.login} />;
  }

  return <>{children}</>;
}
